module.exports = __webpack_public_path__ + "img/IMG_2399_T_FoamcoreMatted.aab5b034.jpg";